import Vue from 'vue'
import Router from 'vue-router'
import UserApps from '@/components/UserApps'
import IdInfos from "@/components/IdInfos"

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {name: 'UserApps'}
    },
    {
      path: '/apps',
      name: 'UserApps',
      component: UserApps
    },
    {
      path: '/apps/:app_key/id_infos',
      name: "IdInfos",
      component: IdInfos
    },
    {
      path: '*',
      redirect: {name: 'UserApps'}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js